import { useQuery } from '@tanstack/react-query';
import { notification } from 'antd';
import { AxiosResponse } from 'axios';

import { apiV1 } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { CompanyUser } from '@company/entities/company';

export type UserSortKey = keyof Omit<CompanyUser, 'role' | 'id'>;

export type MyCompaniesResponse = {
  data: {
    id: string;
    name: string;
    status: string;
    more: {
      logoURL: string;
    };
    roles: {
      id: string;
      name: string;
    } | null;
    tool: {
      id: string;
      createdAt: string | null;
      updatedAt: string | null;
      deletedAt: string | null;
      companyId: string;
      webcast: boolean;
      irm: boolean;
      crm: boolean;
      cms: boolean;
      email: boolean;
      ai?: boolean;
    };
    userCompanyRoles?: {
      companyId: string;
      role: {
        id: string;
        permissions: {
          id: string;
          createdAt: string;
          updatedAt: string;
          deletedAt: null;
          name: string;
          roles: null;
          modules: null;
        }[];
      };
    }[];
  }[];
};

export const getMyCompanies = (): Promise<AxiosResponse<MyCompaniesResponse>> => {
  return apiV1.get(`/public/my-companies`);
};

type QueryFnType = typeof getMyCompanies;

type UseMyCompaniesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useMyCompanies = ({ config }: UseMyCompaniesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    onError: () => {
      notification.error({ message: `Error no servidor! Não foi possível buscar suas empresas` });
    },
    ...config,
    queryKey: [`my-companies`],
    queryFn: () => getMyCompanies(),
  });
};
